// @MX:NOTE: [AUTO] 위챗 자동회신 콘텐츠(<a data-miniprogram-appid=... data-miniprogram-path=...>) 파서.
// MobileEmulator.vue(미리보기 렌더)와 FollowWelcomeMessage.vue(삽입된 링크 목록)가 공유한다.
// [SECURITY] v-html을 사용하지 않기 위한 화이트리스트 파서 — data-miniprogram-appid 속성이 있는
// <a> 태그만 "링크"로 인식하고, 그 외 모든 HTML(알 수 없는 태그·속성)은 리터럴 텍스트로 취급한다
// ({{ }} 바인딩으로 자동 이스케이프되어 렌더링되므로 XSS 벡터가 되지 않는다).

const A_TAG_RE = /<a\b([^>]*)>([\s\S]*?)<\/a>/gi;
const ATTR_RE = /([a-zA-Z_:][-a-zA-Z0-9_:.]*)\s*=\s*(?:"([^"]*)"|'([^']*)')/g;

function parseAttrs(attrString) {
  const attrs = {};
  ATTR_RE.lastIndex = 0;
  let m;
  while ((m = ATTR_RE.exec(attrString)) !== null) {
    const key = m[1].toLowerCase();
    attrs[key] = m[2] !== undefined ? m[2] : m[3];
  }
  return attrs;
}

// content(문자열 또는 { response } 객체)를 세그먼트 배열로 변환한다.
// 반환 세그먼트: { type: 'text', text } | { type: 'link', text, appid, path, raw }
export function parseMessageSegments(raw) {
  const text = typeof raw === 'string'
    ? raw
    : (raw && typeof raw === 'object' ? (raw.response || '') : '');

  if (!text) return [{ type: 'text', text: '' }];

  const segments = [];
  A_TAG_RE.lastIndex = 0;
  let lastIndex = 0;
  let match;

  while ((match = A_TAG_RE.exec(text)) !== null) {
    const [full, attrString, inner] = match;

    if (match.index > lastIndex) {
      segments.push({ type: 'text', text: text.slice(lastIndex, match.index) });
    }

    const attrs = parseAttrs(attrString);

    if (attrs['data-miniprogram-appid']) {
      // 화이트리스트: 미니앱 딥링크로 인식 — 내부 태그 제거한 순수 텍스트만 사용
      const linkText = inner.replace(/<[^>]*>/g, '').trim() || attrs['data-miniprogram-appid'];
      segments.push({
        type: 'link',
        text: linkText,
        appid: attrs['data-miniprogram-appid'],
        path: attrs['data-miniprogram-path'] || '',
        raw: full
      });
    } else {
      // 미인식 태그 — 파싱하지 않고 원문을 리터럴 텍스트로 취급(렌더링 시 자동 이스케이프)
      segments.push({ type: 'text', text: full });
    }

    lastIndex = match.index + full.length;
  }

  if (lastIndex < text.length) {
    segments.push({ type: 'text', text: text.slice(lastIndex) });
  }

  return segments.length ? segments : [{ type: 'text', text: '' }];
}

// 현재 콘텐츠에 포함된 미니앱 링크만 추출한다 (FollowWelcomeMessage.vue 하단 목록용).
export function detectMiniprogramLinks(text) {
  return parseMessageSegments(text).filter((seg) => seg.type === 'link');
}

// 속성값 이스케이프 — 삽입 시 큰따옴표가 태그를 깨지 않도록 방지.
export function escapeAttr(value) {
  return String(value || '').replace(/"/g, '&quot;');
}

// 링크 텍스트 이스케이프 — 삽입 시 사용자가 입력한 텍스트가 태그를 깨지 않도록 방지.
export function escapeText(value) {
  return String(value || '')
    .replace(/&/g, '&amp;')
    .replace(/</g, '&lt;')
    .replace(/>/g, '&gt;');
}

// 미니앱 딥링크 <a> 태그 문자열을 생성한다.
export function buildMiniprogramLinkTag({ appid, path, text, href }) {
  const hrefAttr = href && href.trim() ? ` href="${escapeAttr(href.trim())}"` : '';
  const pathAttr = ` data-miniprogram-path="${escapeAttr(path || '')}"`;
  const appidAttr = ` data-miniprogram-appid="${escapeAttr(appid || '')}"`;
  return `<a${hrefAttr}${appidAttr}${pathAttr}>${escapeText(text)}</a>`;
}
